import React , { Component } from 'react';
import InputText from '../components/formulario/InputText';
import Radio from '../components/formulario/Radio';
import { CONSTANTES } from '../utils/Constantes';
import Select from '../components/formulario/Select';
import Boton from '../components/formulario/Boton';
import Utils from '../utils/Validate';
import CalendarioRango from '../components/formulario/CalendarioRango';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button';
import Popover from 'react-bootstrap/Popover';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-responsive-modal';
import { obtenerRemesas } from '../../service/actions';
import $ from 'jquery';
import ReactTable from 'react-table';
import {ReactTableDefaults} from 'react-table';
import 'react-table/react-table.css'
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import moment from 'moment';
import { Auth, Storage } from 'aws-amplify';
import ModalGenerico from '../components/comunes/ModalGenerico';
import Footer from '../components/comunes/Footer';
import Breadcrumb from '../components/comunes/Breadcrumb';

import {listaUsuarios as data} from '../../service/test.js';
class CrearUsuario extends Component {
    state = {
       
        isLoading       : false,
        m_modal         : '',
        casoModal: '',       
        filtered: [],
        open: false,
        disableDiv: false,
        idremesa: '',
        //Agregando Nuevo
        nombres: '',
        apellidos: '',
        correo: '',
        perfil: 'CORREDOR||Corredor',
        
		

        v_nombres: true,
        v_apellidos: true,
        v_perfil: true,    
        
        v_correo: true,
      
		
        //
        cantidadRemesas:0,      
        formValido: true,        
        
        lista_canal: [
           
        ],
        lista_sub_canal: [
           
        ],
        lstPerfiles : [
            {
                name:"perfil",
                value: 'EJECUTIVO',            
                detalle: 'Ejecutivo'
            },
            {
                name:"perfil",
                value: 'CORREDOR',              
                detalle: 'Corredor'
            },
            {
                name:"perfil",
                value: 'ADMIN',               
                detalle: 'Administrador'
            }
        ],
        atributos : []
    }

    disableDiv = () => {
        this.setState({
           disableDiv:true
        });
    }

    enableDiv = () => {
        this.setState({
           disableDiv:false
        });
    }

    previousPageHandler = () => {
        this.setLocalStorage("FLUJO","1");
        this.props.props.history.push({ pathname : CONSTANTES.RUTA.detalle });
    }

    onCloseModal = ()  => {
        this.setState({ open: false});
    };

    setLocalStorage = (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
      }
    
    

    componentWillMount() {
    }

    async componentDidMount(){
		if("true" !== localStorage.getItem('login')){
            await Auth.signOut();
        }
        this.props.mostrarLoading();
        //this.obtenerValoresAtributo('canal');
        //this.obtenerValoresAtributo('sub_canal');
    }

    timer = () => {
        Auth.currentSession().then(response =>{
            var exp = moment.unix(response.accessToken.payload.exp).format('DD/MM/YYYY hh:mm:ss');
            var fecha_actual = moment(new Date()).format('DD/MM/YYYY hh:mm:ss');
            if(fecha_actual > exp){
                this.cerrarSesion();
            }
		})
		.catch(error =>{
			this.props.props.history.push({ pathname : CONSTANTES.RUTA.login }); 
		});
    }
    limpiarFormulario = () =>{
        this.setState({perfil: 'CORREDOR||Corredor',
                        nombres: '',
                        apellidos: '',
                        correo: ''                        
                    });
        this.state.atributos.map(e=>{
                        this.setState({ [e.key] : ''});
                    });
    }
    validarFormulario = (e) => {
        let response = true;
        if (this.state.perfil == '||' || !this.state.v_perfil){
            this.setState({v_perfil:false});
            response = false;
        }else{
            this.setState({v_perfil:true})
        }
        if (this.state.nombres == '' || !this.state.v_nombres){
            this.setState({v_nombres:false});
            response = false;
        }else{
            this.setState({v_nombres:true})
        }
        if (this.state.apellidos == '' || !this.state.v_apellidos){
            this.setState({v_apellidos:false});
            response = false;
        }else{
            this.setState({v_apellidos:true})
        }
        if (this.state.correo == '' || !this.state.v_correo){
            this.setState({v_correo:false});
            response = false;
        }else{
            this.setState({v_correo:true})
        }
        if ((!this.state.d_codigo_corredor)  && (!this.state.codigo_corredor  || !this.state.v_codigo_corredor)){
            this.setState({v_codigo_corredor:false});
            response = false;
        }else{
            this.setState({v_codigo_corredor:true})
        }
        
        return response;
    }
    validarCampo = (e, callback) => {
        let { value , name, valorDependiente } = e.target;
        this.setState({['v_' + name] : Utils.validarCampo(name, value, valorDependiente)}, () => {
            if (callback) callback();
        });  
    }
    onChange = (e) => {
        let { name, value } = e.target;
        this.setState({ [name] : value }, () => {
        });        
    }

    onDisabled = (e) =>{
        let { name, value } = e;
        this.setState({['d_' + name] : value , [name] : ''}, () => {

        });
    }
    
    /** OBTENER REMESAS */
    crearUsuarioService = (params) => {
        this.props.mostrarLoading();
        this.props.props.callServiceUsuarios("POST","usuarios", {...params}).then(response => {
            // console.log(response);
            this.props.ocultarLoading();
            this.setState({open: false});
            if(response){
                console.log(response);
                if(200 === response.statusCode && 0 === response.body.responseCode){
                    this.limpiarFormulario();
                    this.props.mostrarModal('mensaje', null, 'Se creó el usuario satisfactoriamente.');
                }else{
                    this.props.mostrarModal("mensajeUsuario", null, response.body.responseMessage);
                }
                
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    }
    obtenerValoresAtributo = (atributo) => {
        this.props.mostrarLoading();
        this.props.props.callServiceUsuarios("GET","atributos/"+atributo, { }).then(response => {
            // console.log(response);
            this.props.ocultarLoading();
            if(response){
                //console.log(response);
                if(200 === response.statusCode && 0 === response.body.responseCode){
                    console.log("antes:" + JSON.stringify(this.state['lista_'+atributo])) ;
                    //this.state['lista_'+atributo] = response.body.data.attribute.subAttributes.map(e => ({value: e.key, detalle: e.name}));
                    this.setState({['lista_'+atributo]: response.body.data.attribute.subAttributes.map(e => ({value: e.key, detalle: e.name}))});
                    console.log("despues:" + JSON.stringify(this.state['lista_'+atributo])) ;
                }else{
                    this.props.mostrarModal("mensajeUsuario", null, response.body.responseMessage);
                }
                
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    }
    crearUsuario = () => {
        let request = {
            payload: {
                    name : this.state.nombres,
                    middleName : this.state.apellidos,
                    email : this.state.correo,
                    profile : this.state.perfil.split(CONSTANTES.SEPARADOR)[0],
                    customAttributes : []                   
                }
            };
        /*if (this.state.codigoCorredor)
            request.payload.customAttributes.push({key:'codigo_corredor',value: this.state.codigoCorredor});
        if (this.state.canal && this.state.canal!='||')
            request.payload.customAttributes.push({key:'canal',value: this.state.canal.split(CONSTANTES.SEPARADOR)[0]});
        if (this.state.subcanal && this.state.subcanal!='||')
            request.payload.customAttributes.push({key:'sub_canal',value: this.state.subcanal.split(CONSTANTES.SEPARADOR)[0]});*/
        this.state.atributos.map(e=>{
            if(this.state[e.key] && this.state[e.key]!='||'){
                if(e.format=='texto')
                    request.payload.customAttributes.push({key: e.key, value: this.state[e.key]});
                else
                    request.payload.customAttributes.push({key: e.key, value: this.state[e.key].split(CONSTANTES.SEPARADOR)[1]});
            }
        });
       
        this.crearUsuarioService(request);
    }    

    cerrarSesion = () => {
        this.props.mostrarLoading();      
        new Promise((resolve, reject) => {
          setTimeout(function(){
			//localStorage.clear();
			
            resolve(true);
          },500)
        }).then(() => {
          this.props.ocultarLoading();
          this.props.props.history.push({ pathname : CONSTANTES.RUTA.login });
        })
      }
    
    crear = () => {
        if(this.validarFormulario())       
            this.setState({ open: true});
    }
    generarLabelAtributos = () =>{
        return(
        <>  
          {  this.state.atributos && this.state.atributos.length>0 && this.state.atributos.map((e,index)=>{
              return ((this.state[e.key] && this.state[e.key]!='||') 
                    && (<Col  className="s12 m12 l12" style={{float: "left"}}>
                        {e.name}: {e.format=='texto'?this.state[e.key]:this.state[e.key].split(CONSTANTES.SEPARADOR)[1]}
                    </Col>))
            })
          } 
        </>
        );
    }
    generarComponenteAtributos =  () =>{        
        if(this.state.atributos.length==0)
            this.obtenerAtributos().then(res=>this.setState({atributos: res}));
        return (
            <Row>
                {this.state.atributos && this.state.atributos.length>0 && this.state.atributos.map((e,index)=>{
                    return (
                        <Col className="s12 m12 l12" >
                        { 
                        ((e.format=='texto') &&
                            <InputText
                            name={e.key}
                            placeholder={e.name}
                            value={this.state[e.key]}
                            onBlur= {(ev)=>{
                                            ev.target.valorDependiente = e.datatype?e.datatype:null;
                                            this.validarCampo(ev);                                                        
                                        }
                                    }
                            onChange={this.onChange}
                            validate = {this.state['v_'+e.key]}
                            clase = {"input-v2"}  
                            disabled = {this.state['d_'+e.key]}/>)
                        }
                        {((e.format=='lista') &&
                            <Select 
                            lista = {e.subAttributes.map(el => ({value: el.key, detalle: el.name}))}                                                 
                            titulo = {e.name}                                               
                            name = {e.key}
                            habilitarValorInicial = {true}
                            value = {this.state[e.key]}
                            onChange = {(e) => { 
                                                this.onChange(e); 
                                                this.validarCampo(e);
                                        }}
                            placeholder = {e.name} 
                            validate = {this.state['v_'+e.key]}/>)
                        
                        }
                        </Col>
                    )
                })
                }
            </Row>
        );
    }

    obtenerAtributos = async () => {
        //this.props.mostrarLoading();
        return new Promise((resolve, reject)=>{
            this.props.props.callServiceUsuarios("GET","atributos", {}).then(response => {
                this.props.ocultarLoading();
                if(response){
                    //console.log(response);
                    if(200 === response.statusCode && 0 === response.body.responseCode){
                        resolve(response.body.data.attributes);                        
                    }else{
                        reject(response.body.responseMessage);
                    }
                    
                }
            }).catch( error => {
               reject(error);
            });
        });  
    }

    render=()=>{
        const fontSize = 11;
        var { open,  page } = this.state;
        ReactTableDefaults.column= {...ReactTableDefaults.column, headerClassName: 'tableUserHeader', className:'tableUserCell'};
        //ReactTableDefaults.columnHeaderProps= {...ReactTableDefaults.columnHeaderProps, headerClassName: 'tableUserHeader2', className:'tableUserCell2'};
        
        return(
            <section className="showMntUsuarios container-fluid container-filtercolor">
                    <div className="container container-filter justify-content-start mb-flex-column">
                        <div className="container-filter-info justify-content-start mb-full">
                            <div className="">
                            <Breadcrumb  opciones={this.props.opciones} accionActual={this.props.accionActual} accionDefault={this.props.accionDefault} irDefault={this.props.irListarUsuario}/>
                                <h1><b>Crear</b> usuario</h1>
                                <p>Aquí gestiona la creación de un usuario en el Portal.</p>                                
                            </div>                            
                        </div>                       
                                                
                    </div>
                    <div className="container-fluid d-flex mb-flex-column justify-content-between">
                        <div className={"container boxBuscar mb-w100 d-flex flex-justify-between w100"}>
                            <Col className="s12 m6 l6">
                                <div className="img-crearusuario"/>
                            </Col>
                            <Col className="seccionFiltrar s12 m6 l6">
                                <Row>
                                    <Col className="s12 m4 l4 div-subtitulo" style={{float: "left"}}>
                                        Datos de Usuario
                                    </Col>
                                    <Col className="s12 m3 l2 font-footer" style={{float: "right" ,display: "flex", cursor: "pointer"}} onClick={this.props.irListarUsuario}>
                                        <div className="icon-regresar"/> Regresar
                                    </Col>
                                </Row>
                                <Row>
                                    {/*<div key={`inline-radio`} className="mb-3">
                                        <Col className="s12 m12 l12 div-lbl-radio" style={{float: "left" }}>
                                            Perfil de usuario
                                        </Col>
                                        <Form.Check inline label="Ejecutivo" name="group1" type={"radio"} id={`inline-radio-1`} />
                                        <Form.Check inline label="Corredor" name="group1" type={"radio"} id={`inline-radio-2`} />
                                        <Form.Check inline label="Administrador" name="group1" type={"radio"} id={`inline-radio-3`} />
                                        
                                    </div>*/}
                                    <Col className="s12 m12 l12" >
                                            <Radio
                                            titulo="Perfil de usuario"
                                            opciones={this.state.lstPerfiles}                                                
                                            clase="div-lbl-radio"
                                            onChange={(e) => { 
                                                this.onChange(e); 
                                                this.validarCampo(e);
                                                this.onDisabled({name:'codigo_corredor', value:(e.target.value == 'CORREDOR||Corredor')? false:true});                                                
                                            }}
                                            value={this.state.perfil}
                                            tipo={"horizontal"}
                                            validate={this.state.v_perfil}
                                                />
                                    </Col> 
                                </Row>                                
                                <Row className={"row-form-v2"}>
                                    <Col className="s12 m12 l12" >
                                        <InputText
                                            name="nombres"
                                            placeholder="Nombres"
                                            value={this.state.nombres}
                                            onBlur={this.validarCampo} 
                                            onChange={this.onChange}
                                            validate = {this.state.v_nombres}                                            
                                            clase = {"input-v2"}  />
                                    </Col> 
                                    <Col className="s12 m12 l12" >
                                            <InputText
                                                name="apellidos"
                                                placeholder="Apellidos"
                                                value={this.state.apellidos}
                                                onBlur={this.validarCampo} 
                                                onChange={this.onChange}
                                                validate = {this.state.v_apellidos}
                                                clase = {"input-v2"}  />
                                    </Col>
                                    <Col className="s12 m12 l12" >
                                            <InputText
                                                name="correo"
                                                placeholder="Correo"
                                                value={this.state.correo}
                                                onBlur={this.validarCampo} 
                                                onChange={this.onChange}
                                                validate = {this.state.v_correo}
                                                clase = {"input-v2"}  />
                                    </Col>
                                    </Row>
                                    {this.generarComponenteAtributos()}
                                    <Row>                                    
                                    <Col className="s12 m6 l6" style={{float: "left"}}>
                                        <button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.crear} style={{marginBottom: "10px"}}>CREAR</button>
                                    </Col>
                                </Row>
                                                               
                            </Col>
                        </div>
                        <Modal open={open} onClose={this.onCloseModal} center classNames={{modal: 'modal-sm'}} >                            
                                <div className="header-modal-usuario">
                                    CREACIÓN DE USUARIO
                                </div>
                                <div className="body-modal-usuario">                                       
                                <Row  className="div-modal-det" style={{margin: "auto", float: "none"}}>    
                                    <Col  className="s12 m12 l12 div-subtitulo-modal" style={{float: "left"}}>
                                    ¿Estas seguro de crear el usuario ? Verifica los siguientes datos.
                                    </Col>
                                    <Col  className="s12 m12 l12" style={{float: "left"}}>
                                        Perfil: {this.state.perfil.split(CONSTANTES.SEPARADOR)[1]}
                                    </Col>
                                    <Col  className="s12 m12 l12" style={{float: "left"}}>
                                        Nombre: {this.state.nombres}
                                    </Col>
                                    <Col  className="s12 m12 l12" style={{float: "left"}}>
                                        Apellidos: {this.state.apellidos}
                                    </Col>                                                                     
                                    <Col  className="s12 m12 l12" style={{float: "left"}}>
                                        Correo: {this.state.correo}
                                    </Col>
                                    {this.generarLabelAtributos()}
                                </Row>                                
                                <Row>
                                    <Col className="s12 m6 l4" style={{margin: "auto", float: "left"}}>
                                            <button className={"botonFormulario right btn-small btn-g no-box-shadow"} onClick={this.onCloseModal}  style={{marginBottom: "10px"}}>CANCELAR</button>
                                    </Col>
                                    <Col className="s12 m6 l4" style={{margin: "auto", float: "right"}}>
                                            <button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.crearUsuario} Style={{marginBottom: "10px"}}>CONFIRMAR</button>
                                    </Col>
                                </Row>
                                </div>
                        </Modal>
                                    
                    </div>   
            </section>                          
           
        );
    }
}
export default CrearUsuario
//export default HOC(CrearUsuario);